import { useNavigate } from "react-router-dom";
export default function UIServicesOutCard({ description, icon, title, onMouseOver, }) {
  const navigate = useNavigate();
  return (
    <div
      onMouseOver={onMouseOver}
      className="md:hover:-translate-y-1 hover:shadow-lg duration-700 transition-all transform-gpu flex flex-col py-[18px] px-[24px] bg-white h-[414px] w-[284px] shrink-0 justify-between rounded-lg"
    >
      <div>
        <div className="flex h-[132px] items-center justify-center">
          <img src={icon} alt="Imagen" className="w-[70px] h-[60px]" />
        </div>
        <div className="flex flex-col">
          <div className="text-[#474747] font-bold mb-2 text-[20px] font-BNPPSquareBold">
            {title}
          </div>
          <p className="text-base tracking-tight font-BNPPSquareRegular text-[#474747] ">
            {description}
          </p>
        </div>
      </div>
      <button className="cursor-pointer p-3 text-[#008552] font-OpenSans self-start font-semibold" onClick={() => navigate("/registro")}>
      Comienza aquí
      </button>
   
    </div>
  );
}
